export class SearchRequestConstants {
    FBOID = "FBOID";
    FIRSTNAME = "FIRSTNAME";
    MIDDLENAME = "MIDDLENAME";
    LASTNAME = "LASTNAME";
    REFERRINGFBOID = "REFERRINGFBOID";
    //FOURDIGITSSN = "FOURDIGITSSN";
    LASTFOURSSNDIGITS = "LASTFOURSSNDIGITS";
    // FIRSTSIXDIGITSOFCREDITCARD = "FIRSTSIXDIGITSOFCREDITCARD";
    LASTFOURDIGITSOFCREDITCARD = "LASTFOURDIGITSOFCREDITCARD";
    FROMDATE = "FROMDATE";
    TODATE = "TODATE";
    EMAILADDRESS = "EMAILADDRESS";
    PHONENUMBER = "PHONENUMBER";
    STATE = "STATE";
    CITY = "CITY";
    COUNTRY = "COUNTRY";
    HOMECOUNTRY = "HOMECOUNTRY";
    SPONSORID = "SPONSORID";
    STATUS = "STATUS";
    USERNAME = "USERNAME";
    ORDERNUMBER = "ORDERNUMBER";
    ALL = "ALL";
}


// WEBPACK FOOTER //
// ./src/app/customerservice/common/search-request-constants.ts